import publicBuill from '../../../../components/reimbursement/js/publicBuill'
import BillTableTemplate from '../../../../components/reimbursement/BillTableTemplate'
import axios from 'axios'
export default {
  components: {
    BillTableTemplate
  },
  data() {
    return {
      sumArr: ['', '合计', '', '', '', '', '', ''],
      query: {
        queryRq: [],
        queryDJh: '',
        queryJkr: ''
      },
      /* 查看子组件 */
      queryData: {
        roles: '', // 查看那些单据数据
        rejected: '', // 退回标志
        state: '' // 是否归档 1：未归档 2：已归档
      },
      pageConfig: {
        currentPage: 1,
        pageSizes: [20, 50, 100, 200],
        pageSize: 100,
        total: 0,
        status: 'f3',
        jeArr: [0.00, 0.00, 0.00]
      },
      allDataList: [],
      billBtnAllArr: [false, true, false, false],
      role: '',
      companyName: [],
      startTime: '',
      endTime: new Date().format('yyyy-MM') + '-' + (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate())
    }
  },
  created() {
    publicBuill.setThis(this)
    const data = new Date().format('yyyy')
    var currentMonth = new Date().getMonth() + 1
    this.startTime = data + '-' + currentMonth + '-' + '01'
    this.findPage()
  },
  methods: {
    /* 分页查询 */
    findPage() {
      const loading = this.$loading({
        lock: true,
        text: '查询中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        companyId: this.role,
        time1: this.startTime ? this.startTime + ' 00:00:00' : null,
        time2: this.endTime ? this.endTime + ' 23:59:59' : null,
        djh: this.query.queryDJh === '' ? null : this.query.queryDJh,
        jkr: this.query.queryJkr === '' ? null : this.query.queryJkr,
        currentPage: this.pageConfig.currentPage,
        limit: this.pageConfig.pageSize,
        lrr: localStorage.getItem('userName')
      }
      this.$post('/fesback/statistics/functionsUnToBePaid.z', data).then(res => {
        const je = publicBuill.formatAmount(res.data.je.toFixed(2))
        const tgje = publicBuill.formatAmount(res.data.tgje.toFixed(2))
        this.sumArr = ['', '合计', '', '', '', '', je, tgje]
      })
      this.$post('/fesback/documentPayment/findPaidPage.z', data).then(response => {
        this.allDataList = []
        this.pageConfig.total = 0
        loading.close()
        if (response.data === null) {
          return
        }
        publicBuill.tableDataFormatter(response.data)
        this.allDataList = publicBuill.PaidToBillData(response.data)
        this.pageConfig.total = this.query.queryDJh ? this.allDataList.length : parseInt(response.data[0].count)
      })
      //查询业务公司列表，根据登录人
      const data2 = {
        lrr: localStorage.getItem('userName')
      }
      this.$post('/fesback/statistics/findCompanyName.z', data2).then(res => {
        if (res.data) {
          this.companyName = res.data
          const obj = {}
          obj[0] = '全部'
          obj[1] = ''
          this.companyName.unshift(obj)
        }
      })
    },
    /* 确认 */
    confirmPayment() {
      this.pageConfig.currentPage = 1
      this.findPage()
    },
    /* 分页 */
    handleSizeChange(val) { // 每页多少条
      this.pageConfig.pageSize = val
      this.findPage()
    },
    handleCurrentChange(val) { // 当前页
      this.pageConfig.currentPage = val
      this.findPage()
    },
    exportPaidDocuments() {
      const loading = this.$loading({
        lock: true,
        text: '请稍等',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        companyId: this.role,
        time1: this.startTime ? this.startTime + ' 00:00:00' : null,
        time2: this.endTime ? this.endTime + ' 23:59:59' : null,
        djh: this.query.queryDJh === '' ? null : this.query.queryDJh,
        jkr: this.query.queryJkr === '' ? null : this.query.queryJkr,
        lrr: localStorage.getItem('userName')
      }
      axios.post(
        '/fesback/documentPayment/exportPaidDocuments.z',
        data,
        {
          responseType: 'blob'
        }
      ).then(res => {
        loading.close()
        const fileName = '已支付职能部门单据' + '.xlsx'
        const blob = new Blob([res.data], { type: 'application/octet-stream' })
        const a = document.createElement('a')
        const href = URL.createObjectURL(blob)
        a.href = href
        a.setAttribute('download', fileName)
        a.click()
        URL.revokeObjectURL(href)
      })
    }

  }
}
// eslint-disable-next-line no-extend-native
Date.prototype.format = function(fmt) {
  var o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
